import { render, staticRenderFns } from "./Backgrounds.vue?vue&type=template&id=be8a415c&scoped=true"
import script from "./Backgrounds.vue?vue&type=script&lang=js"
export * from "./Backgrounds.vue?vue&type=script&lang=js"
import style0 from "./Backgrounds.vue?vue&type=style&index=0&id=be8a415c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8a415c",
  null
  
)

export default component.exports